import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.find";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { eventDispatcher, TOPICS } from '@origin-digital/event-dispatcher';
import { logger } from '@origin-digital/reporting-client';
import { isNative, windowExists } from './helpers';
// ODIN removes SharedAppContext on LOGOUT
var SHARED_APP_KEY = 'SharedAppContext';
var SHARED_APP_VERSION_KEY = 'version';
var SHARED_APP_VERSION = '2';

var storage = function storage() {
  return isNative() ? window.localStorage : window.sessionStorage;
};

export var addStorageUpdatedListener = function addStorageUpdatedListener(cb) {
  if (isNative()) {
    var eventListenerSub = function eventListenerSub(event) {
      if (event.key === SHARED_APP_KEY) {
        cb();
      }
    };

    window.addEventListener('storage', eventListenerSub);
    return eventListenerSub;
  }

  return;
};
export var removeStorageUpdatedListener = function removeStorageUpdatedListener(eventListenerSub) {
  if (isNative()) {
    window.removeEventListener('storage', eventListenerSub);
  }
};
export var readStorage = function readStorage() {
  if (windowExists) {
    var json = storage().getItem(SHARED_APP_KEY);

    if (json) {
      return JSON.parse(json);
    }
  }

  return {};
};
export var writeStorage = function writeStorage(obj) {
  if (windowExists) {
    var oldStorage = readStorage();

    try {
      storage().setItem(SHARED_APP_KEY, _JSON$stringify(_objectSpread({}, oldStorage, {}, obj, _defineProperty({}, SHARED_APP_VERSION_KEY, SHARED_APP_VERSION))));
    } catch (error) {
      logger.error('@od/sac: cannot write to storage', error);
    }
  } else {
    logger.error('@od/sac: cannot write to session storage when window does not exist.');
  }
};
export var externallyWriteToSharedAppStorage = function externallyWriteToSharedAppStorage(obj) {
  var oldStorage = readStorage();

  var keys = _Object$keys(obj);

  var needsWrite = keys.find(function (key) {
    return obj[key] !== oldStorage[key];
  }); // check if value has changed

  if (needsWrite) {
    // only write if value has changed
    writeStorage(obj);
    fireSacUpdateEvent();
    return true;
  } else {
    logger.debug('@od/sac: no changes to write to storage');
  }

  return false;
}; // generates a uniqueId, so we can identify different sources that fire events

export var srcUniqueId = "".concat(Math.random() // tslint:disable-next-line:no-magic-numbers
.toString(36) // tslint:disable-next-line:no-magic-numbers
.substr(2, 16));
export var fireSacUpdateEvent = function fireSacUpdateEvent() {
  eventDispatcher.dispatch({
    payload: {
      srcUniqueId: srcUniqueId
    },
    topic: TOPICS.SAC_UPDATE
  });
};